module.exports = __webpack_public_path__ + "media/images/logo2-3a4f1cd6054304c3152049f13f506586.svg";